<template>
    <el-dialog visible width="35%" :title="$t('admin.selectionTips')" @close="onCancel">
      <div class="flex mt-15 justify-center">
        <div
          v-for="item in fapiaoSelectionOptions"
          :key="item.type"
          class="selection-card border-normal"
          :class="[item.checked ? 'selected' : '']"
          @click="handleCheckedChange(item)"
        >
          <div class="selection-btn">
            <el-checkbox v-model="item.checked" @change="handleCheckedChange(item)"></el-checkbox>
          </div>
          <svg-icon :icon-name="item.iconName" :size="64"></svg-icon>
          <p class="label">{{ item.name }}</p>
        </div>
      </div>
  
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="onCancel">{{ $t("comment_reSet") }}</el-button>
        <el-button type="primary" class="wl-green" @click="confirm">{{
          $t("btn_confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import SvgIcon from "@/components/svgIcon/index";
  
  export default {
    name: "FileExportSelection",
    components: {
      SvgIcon,
    },
    props: {
      onCancel: {
        type: Function,
        default: () => {},
      },
      onConfirm: {
        type: Function,
        default: () => {},
      },
    },
    computed: {
      ...mapGetters("common", {
        getUser: "getUser",
        getSite: "getSite",
      }),
    },
    watch: {},
    data() {
      return {
        fapiaoSelectionOptions: [
          {
            iconName: "bill",
            name: `${this.$t("admin.feeNote")}`,
            type: "bill",
            checked: false,
          },
          {
            iconName: "pdf",
            name: `${this.$t("admin.fapiao")} (${this.$t('admin.pdf')})`,
            type: "pdf",
            checked: false,
          },
          {
            iconName: "xml",
            name: `${this.$t("admin.fapiao")} (${this.$t('admin.xml')})`,
            type: "xml",
            checked: false,
          },
          
        ],
      };
    },
  
    mounted() {},
    methods: {
      handleCheckedChange(item) {
        this.fapiaoSelectionOptions.forEach((item) => (item.checked = false));
        item.checked = true;
      },
      confirm() {
        const typeList = this.fapiaoSelectionOptions.filter((item) => item.checked);
        if (typeList.length < 1) {
          this.$message.error(this.$t("admin.selectionTips"));
          return;
        }
        this.onConfirm(typeList[0].type);
      },
    },
  };
  </script>
  
  <style scoped>
  .tips {
    font-weight: bold;
  }
  .selection-card {
    margin: 0 10px;
    padding: 24px;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  
  .selection-card:hover,
  .selected {
    border-color: rgb(129, 153, 238);
    color: rgb(48, 87, 228);
  }
  
  .label {
    font-weight: bold;
    margin-top: 20px;
    font-size: 14px;
  }
  
  .selection-btn {
    position: absolute;
    top: 5px;
    left: 5px;
  }
  </style>
  